import { apiSlice } from '@/store/api/apiSlice';
import { getTransitTimestamp, WeekType } from '@/utils/getTransitTimestamp';

export interface PlanetAspectItem {
  planet: string;
  aspect: number[];
  houseAspect: number[];
  aspectSigns: string[];
}

export const weeklyPlanetAspectsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getWeeklyPlanetAspects: builder.query<PlanetAspectItem[], { weekType?: WeekType }>({
      query: ({ weekType = 'current' }: { weekType?: WeekType } = {}) => ({
        url: '/transits/general-aspect',
        method: 'GET',
        params: {
          timestamp: getTransitTimestamp('weekly', weekType),
        },
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useGetWeeklyPlanetAspectsQuery } = weeklyPlanetAspectsApi;
